<template>
  <div class="container">
    <h4 class="cardD">Cotización Copias Certificadas</h4>

    <h4 class="cardD mt-1">Resumen de Documentos</h4>

    <table class="table table-bordered table-hover table-fixed">
      <thead class="">
        <tr>
          <th class="descripcion-col">Descripción</th>
          <th class="precio-unitario-col">Precio unitario</th>
          <th class="check-col">Número de copias</th>
          <th class="precio-col">Precio</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="doc in documentos_base" :key="doc.id">
          <td class="">{{ doc.tipo }}</td>
          <td class="font-weight-bold precio-col-container">{{ formatCurrency(doc.totalPorCopia) }}</td>
          <td class="">{{ doc.copias_certificadas }}</td>
          <td class="font-weight-bold precio-col-container">{{ formatCurrency(doc.totalDocumento) }}</td>
        </tr>
      </tbody>
    </table>
    <div class="mt-2">
      <div class="container">
        <div class="row justify-content-end">
          <div class="col-3">
            <table class="table table-bordered table-hover">
              <tbody>
                <tr>
                  <td class="">Subtotal</td>
                  <td class="font-weight-bold precio-col-container">{{ formatCurrency(subtotal_documentos) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <h4 class="cardD" v-if="subtotal_extras > 0">Extras</h4>
    <div class="" v-if="subtotal_extras > 0">
      <table class="table table-bordered table-hover table-fixed">
        <thead class="">
          <tr>
            <th class="check-col">Check</th>
            <th class="descripcion-col">Descripción</th>
            <th class="precio-unitario-col">Precio unitario</th>
            <th class="precio-col">Precio</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="urgencia">
            <td class="">✓</td>
            <td class="">Urgencia</td>
            <td class="font-weight-bold precio-col-container">{{ precio_urgencia }}%</td>
            <td class="font-weight-bold precio-col-container">{{ formatCurrency(total_urgencia) }}</td>
          </tr>
          <tr v-if="cotejo.envio_domicilio">
            <td class="">✓</td>
            <td class="">Envío a Domicilio</td>
            <td class="font-weight-bold precio-col-container">{{ formatCurrency(500) }}</td>
            <td class="font-weight-bold precio-col-container">{{ formatCurrency(500) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="mt-2" v-if="subtotal_extras > 0">
      <div class="container">
        <div class="row justify-content-end">
          <div class="col-3">
            <table class="table table-bordered table-hover">
              <tbody>
                <tr>
                  <td class="">Subtotal</td>
                  <td class="font-weight-bold precio-col-container">{{ formatCurrency(subtotal_extras) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-3">
      <h4 class="cardD mt-3 font-weight-bold">Total</h4>
      <div class="mt-2">
        <div class="font-weight-bold total">
          <div>
            <p class="orange-text">{{ formatCurrency(total_previo_descuento) }}</p>
          </div>
        </div>
      </div>
    </div>

    <hr v-if="subtotal_descuento > 0" />
    <h4 class="cardD" v-if="subtotal_descuento > 0">Descuentos</h4>
    <div class="" v-if="subtotal_descuento > 0">
      <table class="table table-bordered table-hover table-fixed">
        <thead class="">
          <tr>
            <th class="check-col">Cantidad</th>
            <th class="descripcion-col">Descripción</th>
            <th class="precio-unitario-col">Precio unitario</th>
            <th class="precio-col">Precio</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="descuento_documentos > 0">
            <td class="">{{ documentos_base.length - 3 }}</td>
            <td class="">Número de Documentos</td>
            <td class="font-weight-bold precio-col-container">{{ formatCurrency(descuentoUnitarioDocumentos) }}</td>
            <td class="font-weight-bold precio-col-container">{{ formatCurrency(descuento_documentos * -1) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="mt-2" v-if="subtotal_descuento > 0">
      <div class="container">
        <div class="row justify-content-end">
          <div class="col-3">
            <table class="table table-bordered table-hover">
              <tbody>
                <tr>
                  <td class="">Subtotal</td>
                  <td class="font-weight-bold precio-col-container">{{ formatCurrency(subtotal_descuento * -1) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <h4 class="cardD mt-1">Cupones</h4>
    <div class="row">
      <div class="col-12">
        <base-input
          type="text"
          label="Si cuenta con un cupón puede aplicarlo."
          placeholder="Cupón de descuento"
          :disabled="cuponAplicado"
          v-model="nombreCuponDescuento"
        ></base-input>
      </div>
      <div class="col-12 d-flex">
        <br />
        <b-button class="orange-btn" size="m" :disabled="cuponAplicado" @click="validarCupon(nombreCuponDescuento)">
          Aplicar
        </b-button>
      </div>
    </div>

    <div class="mt-3" v-if="total_post_descuento != total_previo_descuento">
      <h4 class="cardD mt-3 font-weight-bold">Total</h4>
      <div class="mt-2">
        <div class="font-weight-bold total">
          <div>
            <p class="orange-text">{{ formatCurrency(total_post_descuento) }}</p>
          </div>
        </div>
      </div>
    </div>

    <h4 class="cardD">Referencia</h4>
    <div class="row">
      <div class="col-md-6">
        <ValidationProvider
          name="referencia"
          rules="max:50"
          v-slot="{ errors }"
          :custom-messages="{ max: 'Máximo 50 caracteres' }"
        >
          <base-input
            :disabled="cotejo.disabled"
            type="text"
            label="Si tiene un número de referencia, por favor incluirlo en el siguiente cuadro."
            placeholder="Máx. 50 caracteres"
            v-model="cotejo.referencia"
          ></base-input>
          <span class="cardErrors">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>
    </div>

    <hr />

    <div class="row mt-4">
      <div class="col-md-12">
        <p style="font-size: 13px; text-align: center">
          EN TODOS LOS CASOS ES NECESARIO LA PRESENTACIÓN DE LOS DOCUMENTOS ORIGINALES PARA SU COTEJO.
        </p>
        <p style="font-size: 13px; text-align: center">
          NO SE ENTREGARÁ COTEJO ALGUNO SIN LA PRESENTACIÓN DE DOCUMENTOS ORIGINALES
        </p>
      </div>
    </div>

    <div class="row mt-4" v-for="clausula in cotejo.clausulas_confirmacion" :key="clausula.clausula_confirmacion_id">
      <div class="col-md-12 d-flex">
        <ValidationProvider
          :name="'clausula-confirmacion-' + clausula.clausula_confirmacion_id"
          :rules="{ required: { allowFalse: false } }"
          v-slot="{ errors }"
          :custom-messages="{ required: 'La confirmación es obligatoria' }"
        >
          <div style="display: flex">
            <b-form-checkbox
              class="orange"
              v-model="clausula.confirmado"
              :id="'checkbox-clausula-confirmacion-' + clausula.clausula_confirmacion_id"
              :disabled="false"
            >
              {{ clausula.contenido }}
            </b-form-checkbox>
          </div>
          <span class="cardErrors">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>
    </div>

    <div class="mt-4">
      <div class="row">
        <div class="col-12">
          <b-button
            class="btn-fill orange-btn bottom2"
            size="m"
            @click="submitCotizacion"
            :disabled="isSubmitButtonDisabledComputed"
          >
            Continuar al pago
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CatGastosApi, CuponesApi } from "@/api";
import loadingMixin from "@/mixins/loadingMixin";
import { formatCurrency } from "@/utils/number-utils";

export default {
  name: "CotizacionCopiasCertificadas",

  props: {
    cotejo: { type: Object },
  },

  mixins: [loadingMixin],

  async created() {
    // Si estamos en modo de solo lectura (por ejemplo, después de guardar o visualizar)
    if (this.cotejo.disabled && this.cotejo.cotizacion?.conceptos) {
      Object.assign(this.$data, this.cotejo.cotizacion.conceptos);
      return;
    }

    this.toggleOnLoading();
    try {
      // Guardamos la info del cupón por si ya existía antes del recálculo
      const conceptosPrevios = this.cotejo.cotizacion?.conceptos;
      const cuponPrevio = conceptosPrevios?.cuponAplicado
        ? conceptosPrevios.nombreCuponDescuento
        : null;
      const cuponTipoPrevio = conceptosPrevios?.cuponAplicado
        ? conceptosPrevios.cuponTipo
        : null;
      const cuponDescuentoPrevio = conceptosPrevios?.cuponAplicado
        ? conceptosPrevios.cuponDescuento
        : 0;
      const cuponIdPrevio = conceptosPrevios?.cuponAplicado
        ? conceptosPrevios.cuponId
        : null;

      await this.getGastos();
      this.setExtraVariables();
      this.getDocumentosBase();
      this.calculaTotalPaginas();
      this.calculaTotalPorCopia();
      this.calculaTotalPorDocumento();
      this.calculaSubtotalDocumentos();
      this.calculaUrgencia();
      this.calculaSubtotalExtras();
      this.calculaTotalPrevioDescuentos();
      this.calculaDescuentoDocumentos();
      this.calculaSubtotalDescuento();
      this.calculaTotalPostDescuentos();

      this.costoTotalAntesCupon = this.total_previo_descuento;
      this.cotejo.costo_total = this.costoTotalAntesCupon;

      // Si había un cupón, lo volvemos a aplicar sobre el nuevo total
      if (cuponPrevio) {
        this.nombreCuponDescuento = cuponPrevio;
        if (cuponTipoPrevio) {
          this.cuponAplicado = true;
          this.cuponTipo = cuponTipoPrevio;
          this.cuponDescuento = cuponDescuentoPrevio;
          this.cuponId = cuponIdPrevio;

          if (this.cuponId) {
            if (!this.cotejo.cotizacion) {
              this.cotejo.cotizacion = {};
            }
            this.cotejo.cotizacion.cupones_id = this.cuponId;
          }

          let precio_total = this.cotejo.costo_total;
          if (this.cuponTipo === "Porcentaje" && this.cuponDescuento < 1) {
            precio_total = this.cotejo.costo_total * (1 - this.cuponDescuento);
          } else if (this.cuponTipo === "Monto") {
            precio_total = this.cotejo.costo_total - this.cuponDescuento;
          }
          this.cotejo.costo_total = precio_total;
          this.total_post_descuento = precio_total;
        } else {
          // Retrocompatibilidad si no se tenía guardada la información interna
          await this.validarCupon(cuponPrevio);
        }
      }
    } catch (error) {
      console.error(error);
      this.showErrorToast("No se pudieron obtener los totales. Intente más tarde.");
    } finally {
      if (!this.cuponAplicado) {
        this.costoTotalAntesCupon = this.total_previo_descuento;
        this.cotejo.costo_total = this.costoTotalAntesCupon;
      }
      this.syncCotizacionToStore();
      this.toggleOffLoading();
    }
  },

  data() {
    return {
      // Costos pre-calculados
      cat_gastos: null,
      precio_monto_base: 0,
      precio_pagina_util: 0,
      precio_descuento_3er: 0,
      precio_urgencia: 0,

      // Cantidades
      documentos_base: [],
      paginas_totales: 0,
      descuento_documentos: 0,

      // Subtotales
      subtotal_documentos: 0,
      subtotal_extras: 0,
      subtotal_descuento: 0,

      // Extras
      urgencia: false,
      envioDomicilio: false,

      // Totales
      total_urgencia: 0,
      total_previo_descuento: 0,
      total_post_descuento: 0,

      cuponAplicado: false,
      nombreCuponDescuento: null,
      cuponTipo: null,
      cuponDescuento: 0,
      cuponId: null,
      costoTotalAntesCupon: 0,
    };
  },

  computed: {
    isSubmitButtonDisabledComputed() {
      return this.cotejo.clausulas_confirmacion.some((c) => !c.confirmado);
    },
    descuentoUnitarioDocumentos() {
      if (this.documentos_base.length <= 3 || this.descuento_documentos <= 0) return 0;
      return (this.descuento_documentos / (this.documentos_base.length - 3)) * -1;
    },
  },

  methods: {
    formatCurrency,

    showErrorToast(msg) {
      this.$toast.error(msg, {
        timeout: 4000, //false,
        hideProgressBar: false,
        position: "top-right",
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        closeButton: "button",
        icon: true,
      });
    },

    async getGastos() {
      const conceptos = ["monto_base", "pagina_util", "descuento_3er", "urgencia"];

      const { value } = await CatGastosApi.filtraProcesos({
        page: 0,
        registersPerPage: 0,
        cat_servicios_id: "4",
      });

      this.cat_gastos = value;
      // this.cat_gastos = value.map(g => ({
      //   id: g.id,
      //   servicio: g.servicio,
      //   costo: g.costo,
      //   clave: g.clave
      // }));

      conceptos.forEach((concepto) => {
        const item = this.cat_gastos.find(({ clave }) => clave === concepto);
        if (item) {
          this[`precio_${concepto}`] = item.costo;
        }
      });
    },

    setExtraVariables() {
      this.envioDomicilio = this.cotejo.envio_domicilio === 1;
      this.urgencia = this.cotejo.id_prioridad === 1;
    },

    getDocumentosBase() {
      this.documentos_base = this.cotejo.documentos.filter((doc) => !("anexoDe" in doc));
    },

    calculaTotalPaginas() {
      this.documentos_base = this.documentos_base.map((doc) => {
        const paginas = parseInt(doc.paginas);
        const paginas_anexo = doc.tiene_anexo ? parseInt(doc.paginas_anexo) : 0;
        return { ...doc, totalPaginas: paginas + paginas_anexo };
      });
    },

    calculaTotalPorCopia() {
      this.documentos_base = this.documentos_base.map((doc) => {
        const costo_paginas = doc.totalPaginas * this.precio_pagina_util;
        return { ...doc, totalPorCopia: this.precio_monto_base + costo_paginas };
      });
    },

    calculaTotalPorDocumento() {
      this.documentos_base = this.documentos_base.map((doc) => ({
        ...doc,
        totalDocumento: doc.totalPorCopia * parseInt(doc.copias_certificadas),
      }));
    },

    calculaSubtotalDocumentos() {
      this.subtotal_documentos = this.documentos_base.reduce((sum, doc) => sum + doc.totalDocumento, 0);
    },

    calculaUrgencia() {
      this.total_urgencia = this.urgencia
        ? (this.subtotal_documentos * this.precio_urgencia) / 100
        : 0;
    },

    calculaSubtotalExtras() {
      this.subtotal_extras = this.total_urgencia + (this.envioDomicilio ? 500 : 0);
    },

    calculaTotalPrevioDescuentos() {
      this.total_previo_descuento = this.subtotal_documentos + this.subtotal_extras;
    },

    calculaDescuentoDocumentos() {
      if (this.documentos_base.length <= 3) return;

      const ordenados = this.documentos_base.slice().sort((a, b) => b.totalDocumento - a.totalDocumento);
      const sum = ordenados.slice(3).reduce((acc, doc) => {
        return acc + (doc.totalDocumento * this.precio_descuento_3er) / 100;
      }, 0);

      this.descuento_documentos = parseFloat(sum.toFixed(2));
    },

    calculaSubtotalDescuento() {
      if (this.descuento_documentos > 0) {
        this.subtotal_descuento += this.descuento_documentos;
      }
    },

    calculaTotalPostDescuentos() {
      this.total_post_descuento = this.total_previo_descuento - this.subtotal_descuento;
    },

    submitCotizacion() {
      // this.cotejo.envio_domicilio = this.envioDomicilio ? 1 : 0;
      // this.urgencia ? (this.cotejo.urgencia = 1) : (this.cotejo.urgencia = 2);
      this.cotejo.costo_total = this.total_post_descuento;

      this.syncCotizacionToStore();

      this.$emit("allChecksPassed");
    },

    async validarCupon(texto_cupon) {
      try {
        const time_zone = -(new Date().getTimezoneOffset() / 60);
        const data = {
          nombre: texto_cupon,
          timeZone: time_zone,
        };
        const { id, isValid, tipo, descuento, message } = await CuponesApi.cuponValido(data);

        if (!isValid) {
          this.$toast.warning(message, {
            timeout: 4000,
            hideProgressBar: false,
            position: "top-right",
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            closeButton: "button",
            icon: true,
          });

          return;
        }

        const total = this.cotejo.costo_total;

        let precio_total = 0;

        if (tipo === "Porcentaje" && descuento < 1) {
          precio_total = total * (1 - descuento);
        } else if (tipo == "Monto") {
          precio_total = total - descuento;
        }

        this.cotejo.costo_total = precio_total;
        this.total_post_descuento = precio_total;
        this.cuponAplicado = true;
        this.cuponTipo = tipo;
        this.cuponDescuento = descuento;
        this.cuponId = id;

        if (!this.cotejo.cotizacion) {
          this.cotejo.cotizacion = {};
        }
        this.cotejo.cotizacion.cupones_id = id;
        this.syncCotizacionToStore();

        // En este momento ya se deja al componenete padre actualizar o crear la cotizacion con el nuevo precio
        this.$toast.success("El cupón se aplicó correctamente", {
          timeout: 3000,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });
      } catch (error) {
        console.log(error);

        this.$toast.error("Ocurrió un error al aplicar el cupón.", {
          timeout: 3000,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });
      }
    },

    borrarCupon() {
      this.cotejo.costo_total = this.costoTotalAntesCupon;
      this.cotejo.cotizacion.cupones_id = 0;
      this.nombreCuponDescuento = "";
      this.cuponAplicado = false;
      this.cuponTipo = null;
      this.cuponDescuento = 0;
      this.cuponId = null;
      this.syncCotizacionToStore();
    },

    syncCotizacionToStore() {
      if (!this.cotejo.cotizacion) {
        this.cotejo.cotizacion = {};
      }
      this.cotejo.cotizacion.conceptos = JSON.parse(JSON.stringify(this.$data));
    },
  },
};
</script>

<style scoped>
.table-fixed {
  table-layout: fixed;
  width: 100%;
}

.table {
  width: 100%;
  border-collapse: collapse;
}

.table th,
.table td {
  padding: 8px;
  text-align: left;
}

.check-col {
  width: 10%;
}

.descripcion-col {
  width: 50%;
}

.precio-unitario-col {
  width: 20%;
}

.precio-col {
  width: 20%;
}

.precio-col-container {
  justify-content: flex-end;
}

.total {
  font-weight: bold;
  display: flex;
  justify-content: flex-end;
  padding-right: 20px;
}

.orange-text {
  color: #ea640b;
}
</style>
